/** 상세사유 최소 길이 — 핸드오프 모달 `dl-detailHelp`. */
export const REASON_DETAIL_MIN_LENGTH = 5

export const EXCEL_FILE_NAME = '반품입고'

/** 화주명 목록 한 번에 받는 건수 — 화주 목록 API 를 페이징 없이 전량 받는다. */
export const SHIPPER_LIST_FETCH_SIZE = 10000

export const MESSAGES = {
  shipperRequired: '화주유형/화주명을 선택해 주세요.',
  shipperNameNotInType: '선택한 화주명이 화주유형과 맞지 않습니다. 화주명을 다시 선택해 주세요.',
  plnDateRequired: '입고예정일자를 선택해 주세요.',
  shippersFailed: '화주 목록을 불러오지 못했습니다. 화주명 선택지가 비어 있을 수 있습니다.',
  excelNoRows: '다운로드할 조회 결과가 없습니다.',
  reasonDetailHelp: `${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해주세요.`,
  /** 다운로드 모달 [확인] — 사유코드·상세사유가 비었거나 짧다(뷰가 [확인]을 잠그지만 슬롯도 한 번 더 막는다). */
  downloadReasonInvalid: `사유코드를 고르고 상세사유를 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해 주세요.`,
  /** 서버 상한을 넘겨 일부만 받은 경우 — 정렬·검색이 받은 범위 안에서만 돌기 때문에 반드시 알린다. */
  truncated: (total: number, limit: number) =>
    `조회 결과 ${total.toLocaleString()}건 중 ${limit.toLocaleString()}건만 표시합니다. 조회 조건을 좁혀 주세요.`,
} as const
